import { BaseService } from "./base.service";
import { PrescriptionDeliveryTimeQueryDTO } from "@model/dtos";

class Service extends BaseService {
    async getDeliveryTime(query: PrescriptionDeliveryTimeQueryDTO): Promise<Date | null> {
        return this.get(`/time?${this.parseQuery(query)}`);
    }
}

export const PrescriptionDeliveryService = new Service('/prescription-delivery');